import { getTemplates } from 'store/template/client';
import { MessageTypes } from '../../store/declarations/enums/common/declaration-types';

interface Args {
    templateData: {
        country?: string;
        declarationType?: string;
        formType?: MessageTypes;
    };
}
const getAllDeclarationTemplateNames = async ({ templateData }: Args) => {
    const { country, declarationType, formType } = templateData;
    if (!country || !declarationType || !formType) return;
    const countryParam =
        country?.toUpperCase() === 'IRELAND' ? 'ireland' : country?.toUpperCase() === 'EU' ? 'eu' : 'uk';
    const templates = await getTemplates(countryParam, declarationType as any, formType, { size: 200 });
    const templateNames = templates?.list.map(({ templateName }) => templateName!);
    return new Set(templateNames);
};

export default getAllDeclarationTemplateNames;
